<template>
  <div class="carousel" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="title" placeholder="请输入标题名称" suffix-icon="el-icon-search" @change="onSearch"
        clearable></el-input>
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <div style="cursor: pointer;">
              <el-image style="height: 40px" :src="scope.row.carouselUrl" :preview-src-list="[scope.row.carouselUrl]"
                fit="contain">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="linkType" label="链接类型" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.linkType == 0">--</div>
            <div v-if="scope.row.linkType == 1">课程</div>
            <div v-if="scope.row.linkType == 2">直播</div>
            <div v-if="scope.row.linkType == 3">活动</div>
            <div v-if="scope.row.linkType == 4">图片</div>
            <div v-if="scope.row.linkType == 5">游学</div>
            <div v-if="scope.row.linkType == 6">资讯</div>
          </template> 
        </el-table-column>
        <el-table-column prop="linkName" label="链接名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.linkName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sortNum" label="排序" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" min-width="200">
          <template slot-scope="scope">
            <el-button class="btn" type="primary" plain @click="handleEdit(scope.row)">修改</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      title: "",//标题名称
      tableData: [],//数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.carouselPictureList, {
          params: {
            title: this.title || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },

    // 修改轮播图
    handleEdit(row) {
      this.$router.push({ name: 'addEditDetails', query: { id: row.id, } })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("即将删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(`${this.$api.carouselInfodelete}/${row.id}`)
            .then(res => {
              if (res.code == 100) {
                this.$message.success("删除成功")
                this.getRequestList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => { })
    },
    // 新增轮播图
    handleAdd() {
      this.$router.push({ name: 'addEditDetails', })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },

    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.carousel {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .pic_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    ::v-deep .el-upload--picture-card {
      background-color: #fff;
    }

    ::v-deep .el-upload-list__item-thumbnail {
      object-fit: cover;
    }

    .picurl {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic_uploader {
    position: absolute;
    top: -10px;
    left: 95px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
